import type { IComponent } from "app/@types/ISwSettings";
import { isHidden as checkIsHidden, isLocked as checkIsLocked } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";

const CONVERSION_RATE_COMPONENT_KEY = "WebConversionRates";

export type ConversionRateAvailability = "available" | "locked" | "hidden";

export const getConversionRateAvailability = (): ConversionRateAvailability => {
    const component = (swSettings.components as Record<string, IComponent | undefined>)[CONVERSION_RATE_COMPONENT_KEY];
    if (!component || checkIsHidden(component)) {
        return "hidden";
    }
    if (checkIsLocked(component)) {
        return "locked";
    }
    return "available";
};
